import { defaultClassNames } from "./classNames.default";
export const dnbCustomClassNames = {
    ...defaultClassNames,
    media: {
        block: "container--mg align--center",
        inner: "",
        visual: "container--s align--center"
    },
    pager: {
        navigationButton: 'button button--primary button--arrow'
    }
};
